import React, { Component } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import $ from "jquery";
import "./App.scss";
import "./Global";

import "antd/dist/antd.css";
import "./resources/semantic/theme/semantic-ui.css";
import "./styles/bootstrap.scss";
import "filepond/dist/filepond.min.css";
// import 'react-table-filter/lib/styles.css';
import "./styles/app.scss";

import { store, persistor } from "./state/store/";
import LoginComponent from "./components/Europartners/Login";
import RecoverPasswors from "./components/Europartners/RecoverPassword";
import HomeComponent from "./components/Europartners/Home";
import ContainerDetailComponets from "./components/Europartners/Trazabilidad/Embarques/Container/";
import RequestCompontent from "./components/Europartners/Requests";
import PurchaseOrderCompontent from "./components/Europartners/PurchaseOrder";
import SupplierManagement from "./components/Europartners/SupplierManagement";
import SupplierManagementDetail from "./components/Europartners/SupplierManagement/info";
import POInfoComponent from "./components/Europartners/PurchaseOrder/info";
import AddRequestCompontent from "./components/Europartners/Requests/add";
import AddPlanTrasport from "./components/Europartners/PlanTrasport/add";
import InfoRequestComponente from "./components/Europartners/Requests/info";
import TransportPlanDetail from "./components/Europartners/PlanTrasport/info";
import PlanTransport from "./components/Europartners/PlanTrasport";
import Admin from "./components/Europartners/Admin";
import AssociationEntities from "./components/Europartners/AssociationEntities";
import Alerts from "./components/Europartners/Alerts";
import InfoAlerta from "./components/Europartners/Alerts/info";
import Herramientas from "./components/Europartners/HerramientasL";
import Reportes from "./components/Europartners/Reports";
import MyReportsCreate from "./components/Europartners/Reports/MyReports/Create";
import Trazabilidad from "./components/Europartners/Trazabilidad";
import WrapperRoute from "./components/Middlewares/WrapperRoute";
import shipmentsDetailComponent from "./components/Europartners/Trazabilidad/Embarques/ShipmentsDetail";
import NotFound from "./components/template/pages/notFound";
import Politicas from "./pages/politica_privacidad";
import terminos_condiciones from "./pages/terminos_condiciones";
import GoAnalytics from "./components/Europartners/MyAnalitics/goanalytics";
import QuickSearch from "./components/Europartners/QuickSearch";
import Finanzas from "./components/Europartners/Finanzas";
import GoTimeSensitive from "./components/Europartners/TimeSensitive/gotimesensitive";
import MiPerfil from "./components/Europartners/Perfil";
import loadPO from "./components/Europartners/PurchaseOrder/loadPO";
import loadPOIA from "./components/Europartners/PurchaseOrder/loadPOIA";
import serviceDesk from "./components/Europartners/servicedeskmodule";
import ticketDetail from "./components/Europartners/servicedeskmodule/app/TicketDetails";
import shipmentShare from "./components/Europartners/shareShipment/Embarques/ShipmentsDetail";

import AltaUsuario from "./components/Europartners/Admin/createuser/index";

import ChangePassworsPolicy from "./components/Europartners/ChangePasswordPolicy";

import history from "./history";
import {
  PERMISSIONS,
  moduleActions,
} from "./components/Global/Permission/constants";
import Laboratory from "./components/Europartners/Laboratory";
import ScrollToTop from "./components/Middlewares/ScrollToTop";
$.ajaxPrefilter((o) => (o.async = true));

/*=============================================
=            App Component With Router        =
=============================================*/

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "es",
    };
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter history={history} basename={"/"}>
            <ScrollToTop />
            <Switch>
              <Route exact path="/not-found" component={NotFound} />
              <Redirect to="/not-found" />
              <Route exact path="/" component={LoginComponent}></Route>
              <Route exact path="/oath/:id" component={LoginComponent}></Route>
              <Route
                exact
                path="/shipments-share/:token"
                component={shipmentShare}
              />

              <Route
                exact
                path="/dashboard"
                render={() => (
                  <WrapperRoute
                    name={"dashboard"}
                    accessPermission={PERMISSIONS.DASHBOARD}
                    component={HomeComponent}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/po-visibility"
                render={() => (
                  <WrapperRoute
                    name={"ordernesServicio"}
                    accessPermission={PERMISSIONS.PO_VISIBILITY}
                    component={RequestCompontent}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/po-management"
                render={() => (
                  <WrapperRoute
                    accessPermission={PERMISSIONS.PO_MANAGEMENT}
                    name={"purchaseOrder"}
                    component={PurchaseOrderCompontent}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/supplier-management"
                render={() => (
                  <WrapperRoute
                    name={"supplierManagement"}
                    component={SupplierManagement}
                    accessPermission={PERMISSIONS.SUPPLIER_MANAGEMENT}
                  ></WrapperRoute>
                )}
              ></Route>

              <Route
                exact
                path="/load-po"
                render={() => (
                  <WrapperRoute
                    name={"load_po"}
                    accessPermission={PERMISSIONS.LOAD_PO}
                    component={loadPO}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/load-po-ia"
                render={() => (
                  <WrapperRoute
                    name={"load_po"}
                    accessPermission={PERMISSIONS.LOAD_PO_IA}
                    component={loadPOIA}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/add-so"
                render={() => (
                  <WrapperRoute
                    name={"agregarOrdenServicio"}
                    accessPermission={PERMISSIONS.PO_VISIBILITY}
                    component={AddRequestCompontent}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/transport-plans"
                render={() => (
                  <WrapperRoute
                    name={"planTransport"}
                    accessPermission={PERMISSIONS.TRANSPORT_PLANS}
                    component={PlanTransport}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/users"
                render={() => (
                  <WrapperRoute
                    name={"Admin"}
                    accessPermission={PERMISSIONS.ADMIN}
                    component={Admin}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/entity-association"
                render={() => (
                  <WrapperRoute
                    name={"AssociationEntities"}
                    accessPermission={PERMISSIONS.ENTITY_ASSOCIATION}
                    component={AssociationEntities}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/alerts-notifications"
                render={() => (
                  <WrapperRoute
                    name={"Alertas"}
                    accessPermission={PERMISSIONS.ADMIN}
                    component={Alerts}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/logistics-tools"
                render={() => (
                  <WrapperRoute
                    name={"Herramientas"}
                    accessPermission={PERMISSIONS.LOGISTICS_TOOLS}
                    component={Herramientas}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/my-reports"
                render={() => (
                  <WrapperRoute
                    name={"Reportes"}
                    accessPermission={PERMISSIONS.MY_REPORTS}
                    component={Reportes}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/special-reports/creation"
                render={() => (
                  <WrapperRoute
                    name={"myreports_create"}
                    accessPermission={PERMISSIONS.MY_REPORTS}
                    component={MyReportsCreate}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/shipment-visibility"
                render={() => (
                  <WrapperRoute
                    name={"Trazabilidad"}
                    component={Trazabilidad}
                    accessPermission={PERMISSIONS.SHIPMENTS}
                  ></WrapperRoute>
                )}
              ></Route>
              {/* <Route exact path="/ordenes-compra" render={() => <WrapperRoute name={'OrdenesCompra'} component={OrdenesCompra} ></WrapperRoute>}></Route> */}
              <Route
                exact
                path="/add-trasport-plan"
                render={() => (
                  <WrapperRoute
                    name={"AddPlanTrasport"}
                    accessPermission={PERMISSIONS.TRANSPORT_PLANS}
                    component={AddPlanTrasport}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/analytics"
                render={() => (
                  <WrapperRoute
                    name={"epointAnalytics"}
                    accessPermission={PERMISSIONS.ANALYTICS}
                    component={GoAnalytics}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/terminos-y-condiciones"
                component={terminos_condiciones}
              />
              <Route exact path="/politicas_privacidad" component={Politicas} />
              <Route exact path="/laboratorio" component={Laboratory} />
              <Route
                exact
                path="/finance"
                render={() => (
                  <WrapperRoute
                    name={"finanzas"}
                    accessPermission={PERMISSIONS.FINANCE}
                    component={Finanzas}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/quotes"
                render={() => (
                  <WrapperRoute
                    name={"time_sensitive"}
                    accessPermission={PERMISSIONS.TIME_SENSITIVE}
                    component={GoTimeSensitive}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/my-profile"
                render={() => (
                  <WrapperRoute
                    name={"miperfil"}
                    accessPermission={PERMISSIONS.MY_PROFILE}
                    component={MiPerfil}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/service-desk"
                render={() => (
                  <WrapperRoute
                    name={"serviceDesk"}
                    accessPermission={PERMISSIONS.SERVICE_DESK}
                    component={serviceDesk}
                  ></WrapperRoute>
                )}
              ></Route>

              {/* Routes with params */}
              <Route
                exact
                path="/so-detail-view/:id"
                render={() => (
                  <WrapperRoute
                    name={"ordenServicioDetalle"}
                    filterCustomer={moduleActions.PEDIDO_DETALLE}
                    accessPermission={PERMISSIONS.PO_VISIBILITY}
                    component={InfoRequestComponente}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/shipments-details/:id"
                render={() => (
                  <WrapperRoute
                    name={"shipments-details"}
                    filterCustomer={moduleActions.SHIPMENT_DETALLE}
                    accessPermission={PERMISSIONS.SHIPMENTS}
                    component={shipmentsDetailComponent}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/po-detail-view/:id"
                render={() => (
                  <WrapperRoute
                    name={"purchaseOrderDetail"}
                    accessPermission={PERMISSIONS.PO_MANAGEMENT}
                    component={POInfoComponent}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/tp-detail-view/:id"
                render={() => (
                  <WrapperRoute
                    name={"trasportPlanDetalle"}
                    filterCustomer={
                      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET
                    }
                    accessPermission={PERMISSIONS.TRANSPORT_PLANS}
                    component={TransportPlanDetail}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/container-detail-components/:id"
                render={() => (
                  <WrapperRoute
                    name={"ContainerDetailComponets"}
                    accessPermission={PERMISSIONS.SHIPMENTS}
                    component={ContainerDetailComponets}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/add-user"
                render={() => (
                  <WrapperRoute
                    name={"alta_usuarios"}
                    accessPermission={PERMISSIONS.ADMIN}
                    component={AltaUsuario}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/search/:id*"
                render={() => (
                  <WrapperRoute
                    name={"quick_search"}
                    accessPermission={PERMISSIONS.QUICK_SEARCH}
                    component={QuickSearch}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/user-detail/:id"
                render={() => (
                  <WrapperRoute
                    name={"alta_usuarios"}
                    accessPermission={PERMISSIONS.ADMIN}
                    component={AltaUsuario}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/info-alert/:id"
                render={() => (
                  <WrapperRoute
                    name={"info_alerta"}
                    accessPermission={PERMISSIONS.ADMIN}
                    component={InfoAlerta}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/supplier-management-detail/:id"
                render={() => (
                  <WrapperRoute
                    name={"supplierManagementDetail"}
                    component={SupplierManagementDetail}
                    accessPermission={PERMISSIONS.SUPPLIER_MANAGEMENT}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/ticket-detail/:id"
                render={() => (
                  <WrapperRoute
                    name={"ticketDetail"}
                    accessPermission={PERMISSIONS.SERVICE_DESK}
                    component={ticketDetail}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/recoverpassword/:token"
                component={RecoverPasswors}
              ></Route>

              <Route
                exact
                path="/updatepolicies/:token"
                component={ChangePassworsPolicy}
              ></Route>

              <Route component={NotFound} />
            </Switch>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
